package music.jammers.client.shared.profile.presentation.viewmodel

data class ProfilePageState(
    val profileSavingInProgress: Boolean = false,
    val pageDataLoading: Boolean = true,
    val userName: String = "",
    val telegram: String = "",
    val city: String = "",
    val picture: String = "",
    val error: Throwable? = null,
    val userId: Long? = null,
    val needShowAdminSettingsButton: Boolean = false,
    val telegramOpenVisible: Boolean = false,
    val openUrl: String? = null,
    val editAvailable: Boolean = false,
)